module.exports = __webpack_public_path__ + "static/media/slider4.5b607315.png";